import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  dismissible = true;
  @Input() message: any;
  @Input() type: any;
  

  constructor() { }

  ngOnInit(): void {
   }

}
